import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Construction, ArrowLeft } from 'lucide-react';

const ComingSoon: React.FC<{ title?: string }> = ({ title = "Under Construction" }) => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-tudor-black flex flex-col items-center justify-center text-center p-6">
            <div className="border border-tudor-gold/30 p-12 bg-black/50 rounded-lg max-w-lg w-full relative overflow-hidden">
                {/* Background Stripe */}
                <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-tudor-gold to-transparent opacity-50"></div>

                <Construction className="w-16 h-16 text-tudor-gold mx-auto mb-6 opacity-80" />

                <h1 className="text-3xl font-serif text-tudor-gold tracking-widest uppercase mb-4">
                    {title}
                </h1>

                <div className="h-px w-24 bg-tudor-gray/30 mx-auto my-6"></div>

                <p className="text-gray-400 font-mono mb-8">
                    By Royal Decree, this section is currently being fortified. Check back later for updates.
                </p>

                <button
                    onClick={() => navigate(-1)}
                    className="flex items-center gap-2 mx-auto text-tudor-gold hover:text-white transition-colors uppercase tracking-wider text-sm font-bold"
                >
                    <ArrowLeft size={16} /> Return to Court
                </button>
            </div>
        </div>
    );
};

export default ComingSoon;
